module.exports = __webpack_public_path__ + "static/img/solution_img1.78681d50.png";